// Quiz VA Recruiting — questions + options.
// Le scoring est calculé côté serveur (source de vérité). Le frontend n'a pas besoin de connaître les points.

export const QUIZ_CATEGORIES = [
  { id: "algos", label: "Algorithmes & Plateformes", color: "#CCFF00" },
  { id: "hooks", label: "Hooks & Copywriting", color: "#00D4FF" },
  { id: "montage", label: "Montage Vidéo", color: "#A78BFA" },
  { id: "anglais", label: "Anglais", color: "#10B981" },
  { id: "marketing", label: "Logique Marketing", color: "#F59E0B" },
  { id: "dispo", label: "Disponibilité & Vitesse", color: "#EF4444" },
  { id: "multitache", label: "Multitâche", color: "#EC4899" },
  { id: "soft", label: "Communication", color: "#FFFFFF" },
];

export const QUIZ_QUESTIONS = {
  algos: [
    {
      id: "q_algo_1",
      text: "Sur Instagram Reels, quel est le signal le plus puissant pour passer en Phase 3 (Explore/Reels feed) ?",
      options: [
        { id: "a", text: "Beaucoup de likes" },
        { id: "b", text: "Watchtime ≥ 70% + saves élevés" },
        { id: "c", text: "Avoir beaucoup de followers existants" },
        { id: "d", text: "Hashtags populaires (#viral, #fyp)" },
      ],
    },
    {
      id: "q_algo_2",
      text: "Sur TikTok, à quoi correspond la 'Phase 1 Cold' ?",
      options: [
        { id: "a", text: "Quand le compte n'a pas posté depuis longtemps" },
        { id: "b", text: "Test initial sur 200-500 cold viewers, peu importe le compte" },
        { id: "c", text: "Quand la vidéo a été supprimée puis remise" },
        { id: "d", text: "L'audience qui ne te connaît pas encore" },
      ],
    },
    {
      id: "q_algo_3",
      text: "Quel élément a un coefficient le plus élevé pour l'algo IG en 2026 ?",
      options: [
        { id: "a", text: "Shares en DM (signal nucléaire)" },
        { id: "b", text: "Likes" },
        { id: "c", text: "Followers du créateur" },
        { id: "d", text: "Saves" },
      ],
    },
  ],
  hooks: [
    {
      id: "q_hook_1",
      text: "Quelle est la durée maximale recommandée pour un hook visuel TikTok/Reels ?",
      options: [
        { id: "a", text: "0-1 seconde" },
        { id: "b", text: "0-3 secondes" },
        { id: "c", text: "0-5 secondes" },
        { id: "d", text: "Cela dépend de la durée totale" },
      ],
    },
    {
      id: "q_hook_2",
      text: "Quel hook a le plus haut potentiel viral ?",
      options: [
        { id: "a", text: "'Personne ne te dira ça mais...'" },
        { id: "b", text: "'Aujourd'hui je vais vous parler de...'" },
        { id: "c", text: "'Bonjour à tous !'" },
        { id: "d", text: "'Voici ma routine matinale'" },
      ],
    },
    {
      id: "q_hook_3",
      text: "Un hook 'Curiosity Gap' efficace doit :",
      options: [
        { id: "a", text: "Tout révéler immédiatement" },
        { id: "b", text: "Créer une tension non résolue qui sera payée plus tard dans la vidéo" },
        { id: "c", text: "Faire référence à un meme actuel" },
        { id: "d", text: "Mentionner un chiffre exact" },
      ],
    },
  ],
  montage: [
    {
      id: "q_mont_1",
      text: "Quelle technique augmente le watchtime moyen d'un Reel ?",
      options: [
        { id: "a", text: "Loop invisible : dernière frame ≈ première frame" },
        { id: "b", text: "Plan fixe long pour reposer le viewer" },
        { id: "c", text: "Musique calme tout du long" },
        { id: "d", text: "Une seule prise sans cuts" },
      ],
    },
    {
      id: "q_mont_2",
      text: "Quel est le piège n°1 sur un Reel cross-posté depuis TikTok ?",
      options: [
        { id: "a", text: "Le format n'est pas vertical" },
        { id: "b", text: "L'audio n'est pas tendance" },
        { id: "c", text: "Le watermark TikTok visible (-40% de push IG)" },
        { id: "d", text: "Trop de hashtags" },
      ],
    },
    {
      id: "q_mont_3",
      text: "Quelle fréquence de cuts pour maintenir l'attention en 2026 ?",
      options: [
        { id: "a", text: "1 cut toutes les 5 secondes" },
        { id: "b", text: "1 cut toutes les 1-2 secondes minimum" },
        { id: "c", text: "Pas de cuts pour rester naturel" },
        { id: "d", text: "1 cut au début uniquement" },
      ],
    },
  ],
  anglais: [
    {
      id: "q_eng_1",
      text: "What does 'engagement rate' mean in social media marketing?",
      options: [
        { id: "a", text: "Le ratio interactions/portée d'un post" },
        { id: "b", text: "La date de publication d'un post" },
        { id: "c", text: "Le nombre total d'abonnés" },
        { id: "d", text: "Le coût d'une publicité" },
      ],
    },
    {
      id: "q_eng_2",
      text: "Translate: 'We need to scale this account aggressively this quarter.'",
      options: [
        { id: "a", text: "Nous devons réduire ce compte ce trimestre." },
        { id: "b", text: "Nous devons faire grandir ce compte agressivement ce trimestre." },
        { id: "c", text: "Nous devons fermer ce compte trimestriellement." },
        { id: "d", text: "Nous devons analyser ce compte trois fois." },
      ],
    },
    {
      id: "q_eng_3",
      text: "What is a 'pattern interrupt' in video content?",
      options: [
        { id: "a", text: "Une coupure publicitaire" },
        { id: "b", text: "Un bug visuel" },
        { id: "c", text: "Un changement brutal qui capte l'attention et stoppe le scroll" },
        { id: "d", text: "Un type de transition standard" },
      ],
    },
  ],
  marketing: [
    {
      id: "q_mkt_1",
      text: "Tu dois choisir UNE métrique pour évaluer la santé d'un compte. Laquelle ?",
      options: [
        { id: "a", text: "Watchtime moyen" },
        { id: "b", text: "Nombre de followers" },
        { id: "c", text: "Nombre de likes" },
        { id: "d", text: "Nombre de posts publiés" },
      ],
    },
    {
      id: "q_mkt_2",
      text: "Un compte stagne à 5K abonnés depuis 3 mois. Quelle est la première hypothèse à tester ?",
      options: [
        { id: "a", text: "Acheter des abonnés" },
        { id: "b", text: "Doubler le nombre de posts par jour" },
        { id: "c", text: "Reanalyser hooks et niche : pattern de Reels validés" },
        { id: "d", text: "Changer de plateforme" },
      ],
    },
    {
      id: "q_mkt_3",
      text: "Quelle stratégie convertit le mieux un viral en croissance long terme ?",
      options: [
        { id: "a", text: "Reposter le viral dès le lendemain" },
        { id: "b", text: "Série de 3-5 contenus follow-up dans la même veine + capture email/DM" },
        { id: "c", text: "Changer de niche" },
        { id: "d", text: "Diminuer la fréquence pour rester rare" },
      ],
    },
  ],
  dispo: [
    {
      id: "q_dispo_1",
      text: "Combien d'heures peux-tu dédier à ce poste par semaine ?",
      options: [
        { id: "a", text: "Moins de 10h" },
        { id: "b", text: "10-20h" },
        { id: "c", text: "20-40h" },
        { id: "d", text: "40h+ (full-time)" },
      ],
    },
    {
      id: "q_dispo_2",
      text: "Tu reçois un brief urgent pour un Reel à publier dans 3h. Tu :",
      options: [
        { id: "a", text: "Réponds que ce n'est pas possible" },
        { id: "b", text: "Attends de pouvoir le faire correctement" },
        { id: "c", text: "T'organises immédiatement et livres dans le délai" },
        { id: "d", text: "Délègues à un collègue" },
      ],
    },
    {
      id: "q_dispo_3",
      text: "Combien de temps mets-tu pour monter un Reel standard (15s, 5-7 cuts) ?",
      options: [
        { id: "a", text: "Plus de 4h" },
        { id: "b", text: "2-4h" },
        { id: "c", text: "30 min - 2h" },
        { id: "d", text: "Moins de 30 min" },
      ],
    },
  ],
  multitache: [
    {
      id: "q_mt_1",
      text: "Tu gères 3 comptes en simultané. Comment tu organises ta journée ?",
      options: [
        { id: "a", text: "1 compte par jour à 100%" },
        { id: "b", text: "Sessions structurées (matin/midi/soir) couvrant les 3 comptes" },
        { id: "c", text: "Je fais tout en même temps en multitâche" },
        { id: "d", text: "Je laisse l'algo décider" },
      ],
    },
    {
      id: "q_mt_2",
      text: "Tu dois suivre KPIs + répondre DMs + monter vidéo + planifier post. Tu :",
      options: [
        { id: "a", text: "Bloque des plages dédiées par tâche, sans interruption" },
        { id: "b", text: "Tu fais tout en parallèle en alternant" },
        { id: "c", text: "Tu choisis 1 ou 2 tâches et délègues le reste" },
        { id: "d", text: "Tu commences par la plus simple" },
      ],
    },
  ],
  soft: [
    {
      id: "q_soft_1",
      text: "Tu détectes une chute de reach de 60% sur un compte. Tu :",
      options: [
        { id: "a", text: "Attends de voir si ça remonte tout seul" },
        { id: "b", text: "Notifies immédiatement avec hypothèses + plan d'action proposé" },
        { id: "c", text: "Notifies sans hypothèse" },
        { id: "d", text: "Postes davantage pour compenser" },
      ],
    },
    {
      id: "q_soft_2",
      text: "Comment communiques-tu sur l'avancement de tes tâches ?",
      options: [
        { id: "a", text: "Update quotidien structuré (fait / en cours / blocages)" },
        { id: "b", text: "Quand on me demande" },
        { id: "c", text: "À la fin de la semaine" },
        { id: "d", text: "Quand quelque chose va mal" },
      ],
    },
  ],
};

// Flatten pour itération facile
export const QUIZ_FLAT = QUIZ_CATEGORIES.flatMap(c =>
  (QUIZ_QUESTIONS[c.id] || []).map(q => ({ ...q, category: c.id, categoryLabel: c.label, categoryColor: c.color }))
);

export const VERDICT_META = {
  "Elite": { color: "#10B981", desc: "Recrute immédiatement. Top 5%." },
  "Fort potentiel": { color: "#CCFF00", desc: "Recrute après 1 mise en situation pratique." },
  "À former": { color: "#F59E0B", desc: "Possible avec 2-4 semaines de formation." },
  "Refus": { color: "#EF4444", desc: "Skill gap trop important pour le poste." },
};
